module.exports = __webpack_public_path__ + "static/img/6.66b145a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/zh/6.png
// module id = qYFx
// module chunks = 0